import { InsertLinksModal } from '../components/InsertLinksModal';
import { showModal } from 'owa-modal';

export async function showInsertLinksModalDialog() {
    const [showModalPromise] = showModal(InsertLinksModal);
    await showModalPromise;
}
